import { space } from "@artsy/palette"

export const NAV_BAR_BORDER_OFFSET = 1
export const NAV_BAR_HEIGHT = space(6) - NAV_BAR_BORDER_OFFSET
